export const BASE_URL = "https://api.amiabila.com";
